import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInApprovalStatusIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white",
			style: { mixBlendMode: "multiply" }
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8,
			cy: 8,
			r: 7.5,
			fill: "#F8C782"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.3033 13.3033C12.4312 14.1754 11.3574 14.819 10.1771 15.1771C8.99686 15.5351 7.74651 15.5965 6.53682 15.3559C5.32714 15.1153 4.19547 14.58 3.24205 13.7976C2.28863 13.0151 1.5429 12.0096 1.0709 10.8701C0.598909 9.73063 0.415222 8.49232 0.536114 7.26487C0.657007 6.03743 1.07875 4.85875 1.76398 3.83323C2.44921 2.80771 3.37678 1.967 4.46452 1.38559C5.55227 0.804179 6.76661 0.500001 8 0.5L8 8L13.3033 13.3033Z",
			fill: "#D97F00"
		})
	]
});
const ForwardRef = forwardRef(SvgInApprovalStatusIcon);
export default ForwardRef;
